const MASKED_SSN = /^\*{3}-\*{2}-\d{4}$/;

/** True for a last-4 display value such as `***-**-1234`. */
export function isMaskedSSN(value: string | null | undefined): boolean {
  return MASKED_SSN.test((value ?? "").trim());
}

/**
 * Formats a raw string into XXX-XX-XXXX as the user types.
 * A server mask is left unchanged so the full number is never reconstructed.
 */
export function formatSSN(raw: string): string {
  if (isMaskedSSN(raw)) return raw.trim();
  const digits = raw.replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
}

/** Bare digits, capped at 9. */
export function normalizeSSN(value: string): string {
  return value.replace(/\D/g, "").slice(0, 9);
}

/** Masked values are sent unchanged so the server keeps the stored SSN. */
export function ssnForSubmit(value: string | null | undefined): string {
  const text = (value ?? "").trim();
  if (isMaskedSSN(text)) return text;
  return normalizeSSN(text);
}
